<template>
  <div style="height: 100%; position: absolute;">
    <ob-modal2 :backdrop="false" width="100%" :show.sync="previewPopup" size="modal-body-full">
      <template slot="modal-title"></template>
      <template slot="modal-body">
        <!-- <div style="height:100%;overflow-y: scroll">
          <iframe  :src="previewURL" scrolling="yes" style="width:100%;position:relative;height:100%"></iframe>
        </div> -->
        <object :data="previewURL" type="application/pdf"  style="width:100%;position:relative;height:100%">
        <a :href="previewURL">{{previewURL}}</a>
        </object>
      </template>
      <template slot="modal-footer">
        <template>
           <template>
               <ob-button type="secondary" @click="onEvalutionReportCancel()">{{selectedReport != null && selectedReport.Status == 'Pending' || EvaluationStatus =='Pending' ? "Cancel" :"Close"}}</ob-button>
               <ob-button v-if="$route.name == 'employer-timesheets'|| this.$route.query.from == 'employer-timesheets' || $route.name == 'timesheets-list'"  @click="next()">Next</ob-button>
           </template>
        </template>
      </template>
    </ob-modal2>
  </div>
</template>
<script>
export default {
  props:["openModal","isSupervisor","selectedReport","CurrentView","CanEvaluate" ,"fromTab","iframeURL","showRejectButton","EvaluationStatus"],
  data(){
    return{
      openIframe:false,
      previewPopup:false,
      IsLoading: true,
      openRejectPopup: false,
      openApprovePopup: false
    }
  },
  components:{
  },
  computed: {
    TimeSheetId()
    {
      return this.selectedReport.TimeSheetId
    },
    IsEmployeeView()
    {
      var isEmployeeView = false
      if(this.CurrentView == "dayGridMonth" || this.CurrentView == "customViewYearly" || this.$route.name == 'evaluation')
      {
        isEmployeeView = true
      }
      return isEmployeeView
    },
    previewURL()
    {
      return this.iframeURL
    }
  },
  watch:{
    openModal(val) {
      this.previewPopup = val;
      if (val) { // On Modal Open
       // this.getUrl()
      }
    },
    previewPopup(val) {
      this.$emit('update:openModal', val)
    },
  },
  created() {
    this.previewPopup = this.openModal;
  },
  methods:{
    onEvalutionReportCancel()
    { 
       if (this.$route.name == "employer-timesheets" || this.$route.name == "timesheets-list") {
         events.fire("hideExpenseOption",true);
         this.$parent.$parent.onEvalutionReportClose();
       }
       else
       this.previewPopup = false
    },
    next(){ 
      if (this.$route.name == "employer-timesheets" || this.$route.name == "timesheets-list") {
        events.fire("hideExpenseOption",false);
       this.$parent.$parent.OnOpenEvaluationRating();
      }
      else if(this.$route.query.from == 'employer-timesheets'){
          this.$parent.$parent.$parent.OnOpenEvaluationRatingPopUp();
      }
    },

  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/ApprovalReport.vue